import React from "react";

const PromoBody = () => {
  return <div>PromoBody</div>;
};

export default PromoBody;
